import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Menu1, Menu2, Menu3, Menu4, Favourite, Today, Older, HelpTop, HelpBottom, userRole } from './mock-menu';
import { LoginService } from 'src/app/_services/ApplicationServices/login.service';
import { ILogin } from 'src/app/_services/ApplicationServices/login';
import { Subscription } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
//import { FileService } from 'src/app/dashboard/Help/File.service';
//import { UtilityCryptoService } from 'src/app/common/Utility/utility-crypto.service';
import { AuthService } from 'src/app/_services/CommonServices/auth.service';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/_services/CommonServices/global.service';
import { async } from 'rxjs/internal/scheduler/async';
import { NgxSpinnerService } from 'ngx-spinner';
import { WindowService } from 'src/app/_services/CommonServices/windowservice';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent implements OnInit {


  sucImg = "assets/images/tick.gif";

  oneAtATime = true;

  favMenu1 = Menu1;
  favMenu2 = Menu2;
  favMenu3 = Menu3;
  favMenu4 = Menu4;



  myFavlist = Favourite;

  todayNotification = Today;
  olderNotification = Older;

  topHelpNav = HelpTop;
  bottomHelpNav = HelpBottom;

  roles = userRole;



  userImage = "assets/images/user.png"
  // Feedback
  // openDialog(templateRef: TemplateRef<any>) {
  //   this.dialog.open(templateRef,{ width: '700px', panelClass: "feedbackModal"});
  // }

  modalRef: BsModalRef;
  SapId: string;
  EmployeeName: string;
  EmployeeSubGroup: string;
  OnBehalf: boolean = false;
  Designation: string;
  employeeDetail: ILogin;
  errorMessage: string;
  subScriptionEmpInfo: Subscription;
  DelegationMenuacess: boolean;
  encryptedSAPID: string;
  decryptValue: string;
  TitleName: string;
  encValues: string = '';
  url: string;
  encSapId: string = '';
  encAppId: string = '';

  openDialog(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }


  // Rating
  max = 5
  rate = 1;
  isReadonly = false;
  msg: string = 'Poor';

  handleRate(event) {
    if (this.rate == 1) {
      this.msg = "Poor "
    }
    else if (this.rate == 2) {
      this.msg = "Below Average "
    }
    else if (this.rate == 3) {
      this.msg = "Average "
    }
    else if (this.rate == 4) {
      this.msg = "Good "
    }
    else if (this.rate == 5) {
      this.msg = "Excellent "
    }

  }

  IsShowHeaderDeatils: any = true;

  constructor(private global: GlobalService, private modalService: BsModalService, private loginService: LoginService, private msAuthService: MsalService, private authService: AuthService,
    private autService: AuthService, private router: Router, private SpinnerService: NgxSpinnerService, private win: WindowService) {

  }

  ngOnInit(): void {
    // this.loginService.GetDecryptCodeValue(this.global.getSapId()).subscribe((result) => {
    //   this.global.UserLoggedInSAPID = result.cipherText;
    //   this.GetEmpLoggedinInfo();
    // });  

    if (this.global.getSapId() != null) {
      //this.SpinnerService.show();
      this.myFirstOperation();
      this.checkDelegationMenuItempermission();
    }
    this.IsShowHeaderDeatils = JSON.parse(localStorage.getItem("IsShowHeaderDeatils").toLowerCase());
  }

  async myFirstOperation() {
    const result = await this.loginService.GetDecryptCodeValue(this.global.getSapId());
    result.subscribe((result) => {
      this.global.UserLoggedInSAPID = result.cipherText;
      this.GetEmpLoggedinInfo();
    });
  }


  config = {
    backdrop: true,
    ignoreBackdropClick: true
  };
  openModal(approvedModal: TemplateRef<void>) {
    this.modalRef = this.modalService.show(approvedModal, this.config);
    document.body.classList.add('modal-open2');
  }
  hideSuccessMsg() {
    document.body.classList.remove('modal-open2');
  }
  GetEmpLoggedinInfo() {
    this.loginService.isRefreshed = false;
    //if (this.loginService.isloginPage) {
    this.loginService.getAuthenticationInfo(this.global.UserLoggedInSAPID).subscribe((result) => {
      this.employeeDetail = result;
      //this.employeeDetail = result.Data;
      if (this.employeeDetail[0] != undefined) {
        this.EmployeeName = this.employeeDetail[0]?.EmpName;
        this.TitleName = this.EmployeeName?.split(" ").map(n => n[0]).join("").toUpperCase();
        this.EmployeeSubGroup = this.employeeDetail[0]?.EMEmpSubgroup;
        this.Designation = this.employeeDetail[0]?.EMDesig;
        this.SapId = this.employeeDetail[0]?.EMEmpCode;
        this.loginService.isloginPage = true;
        if (this.employeeDetail[0]?.ADVDelFlag == 1) {
          this.OnBehalf = true;
          this.global.setOnBehalf(this.OnBehalf.toString());
          //localStorage.setItem("Onbehalf", this.OnBehalf.toString());
        }
        else {
          this.OnBehalf = false;
          this.global.setOnBehalf(this.OnBehalf.toString());
          //localStorage.setItem("Onbehalf", this.OnBehalf.toString());
        }
      }
      else {
        // this.EmployeeName = "";
        // this.EmployeeSubGroup = "";
        this.router.navigate(['Unauthorized']);
        this.SpinnerService.hide();
      }
      this.SpinnerService.hide();
    }
    )
    //}
    // else {
    //   this.loginService.getEmployeeInfo(this.global.UserLoggedInSAPID).subscribe((resFromProfile) => {
    //     //console.log("Employeedata1",resFromProfile);
    //     if (resFromProfile[0] != null) {
    //       localStorage.setItem("Role", resFromProfile[0].EMDesig);
    //       //localStorage.setItem('SapId', resFromProfile[0].EMEmpCode);
    //       //essionStorage.setItem('SapId', resFromProfile[0].EMEmpCode);
    //       //localStorage.setItem('EmpName', resFromProfile[0].EmpName);
    //       this.EmployeeName = resFromProfile[0].EmpName;

    //       this.TitleName = "Gopi";//localStorage.getItem("UserName").split(".").map(n => n[0]).join("").toUpperCase();
    //       //console.log("splitname", this.TitleName);
    //       this.EmployeeSubGroup = resFromProfile[0].EMEmpSubgroup;
    //       this.Designation = resFromProfile[0].EMDesig;
    //       this.OnBehalf = resFromProfile[0].ADVDelFlag;
    //       this.SapId = resFromProfile[0].EMEmpCode;
    //       this.loginService.isRefreshed = true;
    //       this.checkDelegationMenuItempermission();
    //       this.SpinnerService.hide();
    //     }
    //     else {
    //       this.router.navigate(['Unauthorized']);
    //       this.SpinnerService.hide();
    //     }
    //   });
    // }
  }
  checkDelegationMenuItempermission() {
    this.loginService.checkAccessOfDelegationReportmenu(this.SapId).subscribe(data => {
      //console.log("ReportAccess",data);
      if (data.StatusCode == 1) {
        this.DelegationMenuacess = true;
      }
    })
  }

  onLogout() {
    this.autService.logout();
    this.authService.logout();
  }
  submitFeedback() {
    this.loginService.pullEncryptValue(this.SapId.toString()).subscribe(res => {
      if (res.clearText != "") {
        this.loginService.isEncrypted = true;
        this.encValues = res.clearText;
        this.encAppId = "/CmHtkGSJ91DqNC1Wxq0Hg=="; //42 AppId
        //this.url = "https://qa1.myhcl.com/feedbacksystem/FeedBack/FeedBack/?id=" + this.encValues  +"&&ApplicationID="+this.encAppId+"&&EmployeeID="+this.encValues,"pop", "status=no,height=200,width=600,resizable=no,left=400,top=100,toolbar=no, menubar=no,scrollbars=yes,location=no, directories=no,closable: false";
        // window.open("https://Wf33.myhcl.com/feedbacksystem/FeedBackDirect/FeedBackDirect?id=" + this.encValues + "&&ApplicationID=" + this.encAppId + "&&EmployeeID=" + this.encValues, "pop", "status=no,height=200,width=600,resizable=no,left=400,top=100,toolbar=no, menubar=no,scrollbars=yes,location=no, directories=no,closable: false");
        this.url = "https://wf33.myhcl.com/feedbacksystem/FeedBack/FeedBack/?id=" + this.encValues + "&&ApplicationID=" + this.encAppId + "&&EmployeeID=" + this.encValues, "pop", "status=no,height=200,width=600,resizable=no,left=400,top=100,toolbar=no, menubar=no,scrollbars=yes,location=no, directories=no,closable: false";
        this.win.open(this.url); 
        
      }
    }
    )
  }


 

}

